import { useState } from 'react';
import { IconLogout, IconChevronDown, IconKey } from '@tabler/icons-react';
import { Avatar } from '../ui/Avatar.js';
import { logoutRequest } from '../../lib/api.js';
import { useAuthStore } from '../../lib/auth.js';
import { Link, useRouter } from '@tanstack/react-router';

export function UserChip() {
  const user = useAuthStore((s) => s.user);
  const router = useRouter();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-pill border border-line bg-white py-1 pl-1 pr-3 hover:border-navy/30 hover:shadow-card transition"
      >
        <Avatar name={user.fullName} size="sm" />
        <span className="text-sm font-medium text-ink hidden sm:inline">
          {user.fullName.split(' ')[0]}
        </span>
        <IconChevronDown size={14} className="text-muted" />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-2 z-20 w-64 rounded-xl bg-white shadow-pop border border-line overflow-hidden">
            <div className="px-4 py-3 border-b border-line">
              <div className="text-sm font-semibold text-ink">{user.fullName}</div>
              <div className="text-xs text-muted truncate">{user.email}</div>
              <div className="badge mt-2 bg-cream-deep text-navy">{user.role.replace('_', ' ')}</div>
            </div>
            <Link
              to="/app/settings"
              onClick={() => setOpen(false)}
              className="w-full flex items-center gap-2 px-4 py-3 text-sm text-ink hover:bg-cream-deep/60 transition border-b border-line"
            >
              <IconKey size={16} className="text-muted" />
              Account settings
            </Link>
            <button
              onClick={async () => {
                await logoutRequest();
                router.navigate({ to: '/login' });
              }}
              className="w-full flex items-center gap-2 px-4 py-3 text-sm text-ink hover:bg-cream-deep/60 transition"
            >
              <IconLogout size={16} className="text-muted" />
              Sign out
            </button>
          </div>
        </>
      )}
    </div>
  );
}
